import React, { useState, useEffect } from "react";
import { useLoadScript } from "@react-google-maps/api";
import MapPicker from "./components/MapPicker";
import LocationInput from "./components/LocationInput";
import Modal from "react-modal";
import { FaMapMarkerAlt, FaHistory, FaTimes } from "react-icons/fa";
import AdministrationDashboard from "./AdministrationDashboard";
import { useNavigate } from "react-router-dom"; // Import useNavigate

const LOCAL_STORAGE_KEY_LOCATION = "recentLocations";

const BranchLocation = () => {
  const navigate = useNavigate(); // Initialize useNavigate
  const [location, setLocation] = useState("");
  const [coordinates, setCoordinates] = useState(null);
  const [isMapOpen, setMapOpen] = useState(false);
  const [recentLocations, setRecentLocations] = useState([]);

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: "AIzaSyA4ZQWDwYRHmhu66Cb1F8DgXbJJrArHYyE",
    libraries: ["places"],
  });

  useEffect(() => {
    const loadRecentLocations = () => {
      const locations = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY_LOCATION)) || [];
      setRecentLocations(locations);
    };

    loadRecentLocations();
  }, []);

  const handleLocationSelect = (coords, address) => {
    setCoordinates(coords);
    setLocation(address);
    setMapOpen(false);
    updateRecentLocations(address, coords);
  };

  const updateRecentLocations = (address, coords) => {
    const recent = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY_LOCATION)) || [];
    const updated = recent.filter((loc) => loc.address !== address);
    const newEntry = { address, coords };
    const newRecentLocations = [newEntry, ...updated].slice(0, 5);
    localStorage.setItem(LOCAL_STORAGE_KEY_LOCATION, JSON.stringify(newRecentLocations));
    setRecentLocations(newRecentLocations);
  };

  const handleRecentLocationSelect = (coords, address) => {
    handleLocationSelect(coords, address);
    setLocation(address);
  };

  const handleSubmit = () => {
    if (!coordinates) {
      alert("Please select a location.");
      return;
    }
  
    // Log the selected location to the console
    const locationDetails = {
      address: location,
      coordinates: coordinates,
    };
  
    // Navigate back to AdminCreateBranch with location details
    navigate('/AdminCreateBranch', { state: { locationDetails } });
  };

  const customModalStyles = {
    content: {
      top: "0%",
      left: "0%",
      right: "0%",
      bottom: "0%",
      transform: "none",
      width: "100%",
      height: "100%",
      padding: "0",
      border: "none",
      borderRadius: "0",
      overflow: "hidden",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.75)",
    },
  };

  if (loadError) return <div>Error loading maps</div>;
  if (!isLoaded) return <div>Loading maps...</div>;

  return (
    <AdministrationDashboard>
      <div className="container py-4">
        <div className="mx-auto card shadow-sm p-4" style={{ maxWidth: "720px" }}>
          <h1 className="h4 mb-4 text-center">Location Picker</h1>

          {/* Location Container */}
          <div className="mb-4 p-3 border rounded bg-light">
            <label className="form-label">Location</label>
            <div className="input-group">
              <div className="form-floating flex-grow-1">
                <LocationInput
                  placeholder="Enter location"
                  value={location}
                  onChange={setLocation}
                  onSelect={(coords, address) => handleLocationSelect(coords, address)}
                />
              </div>
             
            </div>
            

            <div style={{marginTop: 30}}>
            <button
                onClick={() => setMapOpen(true)}
                className="btn btn-warning"
                style={{background: 'purple', border: 'none', color: 'white'}}
              >
                Use Map To Pick Location
              </button>
            </div>

            {/* Recent Locations */}
            {recentLocations.length > 0 && (
              <div className="mt-3">
                <div className="d-flex align-items-center text-secondary small mb-2">
                  <FaHistory className="me-1" />
                  Recent Locations
                </div>
                <div className="list-group">
                  {recentLocations.map((location, index) => (
                    <div
                      key={index}
                      onClick={() =>
                        handleRecentLocationSelect(location.coords, location.address)
                      }
                      className="list-group-item list-group-item-action"
                      style={{ cursor: "pointer" }}
                    >
                      {location.address}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          <button
            onClick={handleSubmit}
            className="btn btn-warning w-100"
            disabled={!coordinates}
            style={{backgroundColor: 'purple', border: 'none', color: 'white'}}
          >
            Continue
          </button>
        </div>

        {/* Modal */}
        <Modal
          isOpen={isMapOpen}
          onRequestClose={() => setMapOpen(false)}
          style={customModalStyles}
        >
          <div className="position-relative h-100">
            <div className="border-bottom p-3">
              <h2 className="h5">Select Location</h2>
            </div>
            <button
              onClick={() => setMapOpen(false)}
              className="btn-close position-absolute top-0 end-0 m-3"
            >
              <FaTimes />
            </button>
            <MapPicker
              onLocationSelect={(coords, address) => handleLocationSelect(coords, address)}
            />
          </div>
        </Modal>
      </div>
    </AdministrationDashboard>
  );
};

export default BranchLocation;